import React from "react";
import { Outlet } from "react-router-dom";
import Box from "@carrier-io/air-react/Box";
import Paper from "@carrier-io/air-react/Paper";
import Grid from "@carrier-io/air-react/Grid";
import { CustomTerms, CustomPolicy } from "../components/terms";
import Typography from "@carrier-io/air-react/Typography";

export const AuthLayout: React.FC = () => {
  return (
    <div
      style={{
        backgroundColor: " #2341E0",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Paper style={{ padding: "40px 40px 40px 40px", width: "338px" }}>
        <Grid
          container
          direction={"column"}
          spacing={2}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Grid>
            <Box
              data-testid="logo"
              style={{
                width: 240,
                height: 96,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                alt="Logo"
                src="https://images.carriercms.com/image/upload/v1629825291/common/logos-svg/carrier-logo.svg"
                style={{
                  width: 140,
                  height: 70,
                }}
              />
            </Box>
          </Grid>

          {/* @ts-expect-error - Known issue with Outlet types */}
          <Outlet />

          <Grid
            container
            direction={"column"}
            spacing={1}
            sx={{ width: "100%", marginTop: "20px" }}
          >
            <Grid container justifyContent="center">
              <Grid>
                <img
                  alt="Logo"
                  src="https://images.carriercms.com/image/upload/v1629825291/common/logos-svg/carrier-logo.svg"
                  style={{ width: 90, height: 47 }}
                />
                <Typography variant="body3" color="#63676B">
                  © {new Date().getFullYear()} Carrier
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction={"row"}
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid>
                <CustomTerms />
              </Grid>
              <Grid>
                <CustomPolicy />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};
